import React from "react"
import { isEqual } from "underscore"

import { Dropdown } from "../common/Dropdown"

const MemoisedDropdown = React.memo(Dropdown, (prevProps, nextProps) =>
  isEqual(prevProps, nextProps),
)

export default MemoisedDropdown
